module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif(environment.style == 'mobile'){\nvar title = (model.titleMobile != \"\" ? model.titleMobile : model.title);\nvar text  = (model.textMobile != \"\"  ? model.textMobile  : model.text);\n%>\n<%- include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: model.img, _img: model._img } }); %>\n<%\n}\nelse {\n%>\n<div class=\"texts\">\n<h3><%- model.title %></h3>\n<p><%- model.text %></p>\n<%- include('../../button/button', { model: model }); %>\n</div>\n<div class=\"images owl-carousel owl-theme\">\n<%\n// image(s) given\nif (!utils.isEmpty(model.img)){\n// get list of detected rendered images\nvar imageList = helpers.detectRenderedImages(model.img, model._img);\n// a list of images results in an carousel\nimageList.forEach(function(image){\n%>\n<div class=\"item\">\n<div class=\"title\"><%= image.rendered.title %></div>\n<div class=\"img\" style=\"background-image: url(<%= image.rendered.url %>%>);\"></div>\n</div>\n<%\n})\n}\n%>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "components/templates/standard/tl-gr/tl-gr.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if(environment.style == 'mobile'){
var title = (model.titleMobile != "" ? model.titleMobile : model.title);
var text  = (model.textMobile != ""  ? model.textMobile  : model.text);

    ; __line = 6
    ; __append("\n")
    ; __line = 7
    ; __append( include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: model.img, _img: model._img } }) )
    ; __append("\n")
    ; __line = 8
    ; 
}
else {

    ; __line = 11
    ; __append("\n<div class=\"texts\">\n<h3>")
    ; __line = 13
    ; __append( model.title )
    ; __append("</h3>\n<p>")
    ; __line = 14
    ; __append( model.text )
    ; __append("</p>\n")
    ; __line = 15
    ; __append( include('../../button/button', { model: model }) )
    ; __append("\n</div>\n<div class=\"images owl-carousel owl-theme\">\n")
    ; __line = 18
    ; 
// image(s) given
if (!utils.isEmpty(model.img)){
// get list of detected rendered images
var imageList = helpers.detectRenderedImages(model.img, model._img);
// a list of images results in an carousel
imageList.forEach(function(image){

    ; __line = 25
    ; __append("\n<div class=\"item\">\n<div class=\"title\">")
    ; __line = 27
    ; __append(escapeFn( image.rendered.title ))
    ; __append("</div>\n<div class=\"img\" style=\"background-image: url(")
    ; __line = 28
    ; __append(escapeFn( image.rendered.url ))
    ; __append(");\"></div>\n</div>\n")
    ; __line = 30
    ; 
})
}

    ; __line = 33
    ; __append("\n</div>\n")
    ; __line = 35
    ; 
}

    ; __line = 37
    ; __append("\n</div>")
    ; __line = 38
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/standard/tl-gr/tl-gr.ejs

}